import React from 'react'
import { TextContainer, Modal } from '@shopify/polaris'
import { SortableContainer, SortableElement } from 'react-sortable-hoc'

import './mapper-list.css'

const MapperListComponent = (props) => {
  const SortableItem = SortableElement(({item}) => <div className="mapper-list__item">
    <Modal.Section>
      <TextContainer>
        <p>{item.name}</p>
      </TextContainer>
    </Modal.Section>
  </div>)

  const SortableList = SortableContainer(({items}) => {
    return (
      <div className="mapper-list">
        {items.map((item, index) => (
          <SortableItem key={index} index={index} item={item} />
        ))}
      </div>
    )
  })
  return (
    <div>
      {
        props.list && props.list.length > 0 && (
          <div>
            <div>
              <div className="Polaris-Labelled__LabelWrapper">
                <div className="Polaris-Label">
                  <label className="Polaris-Label__Text">Selected mappers</label>
                </div>
              </div>
              <div className="Polaris-Labelled__HelpText">
                Drag &amp; drop to re-order mapper index within slider.
              </div>
            </div>
            <SortableList items={props.list} onSortEnd={props.onSortEnd} />
          </div>
        )
      }
    </div>
  )
}

export default MapperListComponent
